// extracted by css-extract-rspack-plugin
export default {"row":"kEjLnMoGvVY4rr32","emptyWarning":"pcfMJarKi_0CFxH4"};